import { UserV3 } from '@wegoTypes/userV3';

import { UserV3ActionTypes } from './types';

export const changeUserV3 = (userV3: UserV3): { type: UserV3ActionTypes; payload: UserV3 } => ({
  type: UserV3ActionTypes.ChangeUserV3,
  payload: userV3,
});

export const resetUserV3 = (): { type: UserV3ActionTypes; payload: null } => ({
  type: UserV3ActionTypes.ResetUserV3,
  payload: null,
});
